import { createFileRoute } from "@tanstack/react-router";
import CompareCargowise from "@/pages/CompareCargowise";
import { pageHead } from "@/lib/seo";

export const Route = createFileRoute("/compare/cargonova-vs-cargowise")({
  head: () => pageHead("/compare/cargonova-vs-cargowise", "en"),
  component: CompareCargowise,
});
